export default __webpack_public_path__ + "static/media/Abyssal Cape of the Fallen Empire.fb268ba7.jpg";